import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Bot, MessageCircle, Phone, Plus, X } from "lucide-react";
import { PHONE_OFFICE, WHATSAPP_URL } from "../lib/api";
import { useLeadModal } from "./ConversionContactModal";
import { useSectionNavigation } from "../lib/navigation";

export default function FloatingConcierge() {
  const [open, setOpen] = useState(false);
  const openLead = useLeadModal();
  const goToSection = useSectionNavigation();

  const actions = [
    {
      icon: <Bot size={16} />,
      label: "Assistente AI",
      testid: "concierge-ai",
      onClick: () => {
        setOpen(false);
        goToSection("assistente");
      },
    },
    {
      icon: <Phone size={16} />,
      label: "Chiama l'ufficio",
      href: PHONE_OFFICE,
      testid: "concierge-call",
    },
    {
      icon: <MessageCircle size={16} />,
      label: "WhatsApp",
      href: WHATSAPP_URL,
      external: true,
      testid: "concierge-whatsapp",
    },
    {
      icon: <Plus size={16} />,
      label: "Richiedi il percorso",
      testid: "concierge-lead",
      onClick: () => {
        setOpen(false);
        openLead();
      },
    },
  ];

  return (
    <div className="fixed bottom-6 right-5 z-[90] flex flex-col items-end gap-3 sm:bottom-8 sm:right-8">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 14, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.96 }}
            transition={{ duration: 0.25 }}
            className="w-[248px] border border-[#c9a45c]/35 bg-[#0d0d0d]/97 p-2 shadow-[0_30px_60px_rgba(0,0,0,0.6)] backdrop-blur-xl"
            data-testid="concierge-menu"
          >
            <p className="px-3 py-2 text-[9px] font-bold uppercase tracking-[0.22em] text-gold">
              A.C. HUB — Contatto diretto
            </p>
            {actions.map((a) =>
              a.href ? (
                <a
                  key={a.testid}
                  href={a.href}
                  {...(a.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  data-testid={a.testid}
                  onClick={() => setOpen(false)}
                  className="flex items-center gap-3 px-3 py-2.5 text-[12px] text-cream transition-colors hover:bg-[#c9a45c]/10 hover:text-gold-light"
                >
                  {a.icon}
                  {a.label}
                </a>
              ) : (
                <button
                  key={a.testid}
                  data-testid={a.testid}
                  onClick={a.onClick}
                  className="flex w-full items-center gap-3 px-3 py-2.5 text-left text-[12px] text-cream transition-colors hover:bg-[#c9a45c]/10 hover:text-gold-light"
                >
                  {a.icon}
                  {a.label}
                </button>
              )
            )}
          </motion.div>
        )}
      </AnimatePresence>
      <button
        data-testid="concierge-fab"
        aria-label={open ? "Chiudi il contatto rapido" : "Apri il contatto rapido"}
        onClick={() => setOpen((v) => !v)}
        className="flex h-11 w-11 items-center justify-center rounded-full border border-[#e1c47a]/70 bg-gradient-to-br from-[#d9b76e] to-[#b38f45] shadow-[0_14px_34px_rgba(201,164,92,0.35)] transition-transform duration-300 hover:scale-105 sm:h-12 sm:w-12"
      >
        {open ? <X size={18} /> : <MessageCircle size={18} />}
      </button>
    </div>
  );
}
